import React, { FunctionComponent } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconClose: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faTimes} />;

export { BrassIconClose };
